const header = (state = { text: '首页' }, action = {}) => {

    switch (action.type) {
        case 'SET_TITLE':
            return {
                text: action.text
            };

        default:
            return state;
    }
};
export default header;


// WEBPACK FOOTER //
// ./src/reducers/header.js